export default "__VITE_ASSET__DXzruJJT__"